import { supabase } from "@/integrations/supabase/client";

export async function fixTwilioCredentials(
  tenantId: string, 
  twilioSid: string, 
  twilioAuthToken: string
): Promise<boolean> {
  try {
    const { data, error } = await supabase.functions.invoke('Calie_fix_credentials', {
      body: {
        accountSid: twilioSid,
        authToken: twilioAuthToken,
      },
    });

    if (error) {
      console.error('Error fixing Twilio credentials:', error);
      return false;
    }

    console.log('Twilio credentials fixed successfully:', data);
    return true;
  } catch (error) {
    console.error('Failed to fix Twilio credentials:', error);
    return false;
  }
}